// extracted by mini-css-extract-plugin
export default {"loader":"LoadingIndicator_loader__UTumE","spin":"LoadingIndicator_spin__DGhAG"};